<script setup lang="ts">
// The content may animate in, but the box around it would snap to its new height: animate the container from the
// content's last height to the new one. The content is measured, not the container, whose height the animation drives.
// No overflow clipping: it would cut the floated labels and the focus rings, and the growing content is still fading in.
const container = useTemplateRef<HTMLDivElement>('container');
const content = useTemplateRef<HTMLDivElement>('content');
const reducedMotion = usePreferredReducedMotion();
let contentHeight: number | undefined;
useResizeObserver(content, ([entry]) => {
  const height = entry?.borderBoxSize[0]?.blockSize;
  if (height === undefined) return;
  if (contentHeight !== undefined && contentHeight !== height && reducedMotion.value !== 'reduce') {
    container.value?.animate([{ height: `${contentHeight}px` }, { height: `${height}px` }], {
      duration: 300,
      easing: 'ease-out',
    });
  }
  contentHeight = height;
});
</script>

<template>
  <div ref="container">
    <div ref="content">
      <slot />
    </div>
  </div>
</template>
